import React from 'react';
import { Hero } from './components/Hero';
import { SoundsLikeThis } from './components/SoundsLikeThis';
import { WorksLikeThis } from './components/WorksLikeThis';
import { BeautifullyRetro } from './components/BeautifullyRetro';
import { MakeItYours } from './components/MakeItYours';
import { PersonalizedVoicemails } from './components/PersonalizedVoicemails';
import { AffordablePackages } from './components/AffordablePackages';
import { JustUs } from './components/JustUs';
import { PhotoCollage } from './components/PhotoCollage';
import { ReadyToBook } from './components/ReadyToBook';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen w-full overflow-x-hidden" data-id="element-0">
      <Hero data-id="element-1" />

      {/* Decorative wave divider */}
      <div className="w-full -mt-1" data-id="element-2">
        <img src="https://cdn.magicpatterns.com/uploads/rKzuDNF1c2vb4EqcnAUeoG/Screenshot_2026-01-14_at_5.51.38_AM.png" alt="" className="w-full h-auto block" data-id="element-3" />
      </div>

      <SoundsLikeThis data-id="element-4" />
      <WorksLikeThis data-id="element-5" />
      <BeautifullyRetro data-id="element-6" />
      <MakeItYours data-id="element-7" />
      <PersonalizedVoicemails data-id="element-8" />
      <AffordablePackages data-id="element-9" />
      <JustUs data-id="element-10" />
      <PhotoCollage data-id="element-11" />
      <ReadyToBook data-id="element-12" />
      <Footer data-id="element-13" />
    </main>;
}